module.exports = __webpack_public_path__ + "static/media/icon_references.96bf47f5.svg";